import { Controller } from "@hotwired/stimulus"
import { portraitAppearance } from "../utils/avatar_appearance"

// The settings select reflects the responsive default without saving it just
// because someone visited Settings. The existing form saves actual changes.
export default class extends Controller {
    changed() {
        this.element.name = "appearance"
        window.dispatchEvent(new CustomEvent("jane:appearance", { detail: { appearance: this.element.value } }))
    }

    connect() {
        if (!this.element.dataset.avatarAppearanceValue) this.element.removeAttribute("name")
        this.element.value = portraitAppearance(this.element.dataset.avatarAppearanceValue) ? "portrait" : "character"
    }
}
